/** The admin route table: each route's path segment and title (TopNav, PageHeader, breadcrumbs). */
export const paths = {
  ROOT: {
    path: "/",
    title: "Home",
  },
  ORGANIZATIONS: {
    path: "organizations",
    title: "Organizations",
  },
  ORGANIZATION: {
    path: ":organizationId",
    title: "Organization",
  },
  ACCESS_CONTROL: {
    path: "rbac",
    title: "Access Control",
  },
  GLOBAL_CONTENTS: {
    path: "global-content",
    title: "Global Content",
    // Only its :contentId pages exist, so its crumb is not a link
    hasPage: false,
  },
  GLOBAL_CONTENT: {
    path: ":contentId",
    title: "Global Content Summary",
  },
  STAKEHOLDERS: {
    path: "stakeholders",
    title: "Stakeholders",
    defaultQueryParams: {
      page: 1,
      pageSize: 20,
    },
  },
  STAKEHOLDER_DETAILS: {
    path: ":stakeholderId",
    title: "Details",
  },
  SUPERPROMPTS: {
    path: "superprompts",
    title: "Super Prompts",
  },
  SCRAPERS: {
    path: "Scrapers",
    title: "Scrapers",
  },
  SCRAPER_DETAILS: {
    path: ":scraperId",
    title: "Details",
  },
  INSIGHT_TOOLS: {
    path: "insight-tools",
    title: "Insight tools",
  },
  SPECIAL_PERMISSIONS: {
    path: "special-permissions",
    title: "Special permissions",
  },
  MANAGE_ASSETS: {
    path: "manage-assets",
    title: "Manage assets",
  },
  GENIE_KNOWLEDGE: {
    path: "genie-knowledge",
    title: "Genie knowledge",
  },
  GENIE_PLUS_USAGE: {
    path: "genie-plus-usage",
    title: "GeniePlus Usage",
  },
};
